import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message.service';
import { GlobalsService } from 'src/app/services/globals.service';
import { Subscription } from 'rxjs';
import { SubscriptionManager } from '../helpers/subscriptionManager';
import { UserService } from '../services/api/user.service';

@Component({
  selector: 'app-transfer-hours-dialog',
  templateUrl: 'transfer-hours.dialog.component.html'
})
export class TransferHoursDialogComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  subscription: Subscription;
  recipientUserIdOrEmail: string;
  hoursToTransfer: number;
  comment: string;
  confirmTransfer: boolean;

  private subscriptionManager = new SubscriptionManager();

  constructor(
    public globals: GlobalsService,
    public dialogRef: MatDialogRef<TransferHoursDialogComponent>,
    private messageService: MessageService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.recipientUserIdOrEmail = '';
    this.hoursToTransfer = 1;
    this.comment = '';
    this.confirmTransfer = false;
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.subscriptionManager.add(this.globals.getIsLoading().subscribe(value => (this.isLoading = value)));
  }

  get canSubmit(): boolean {
    return (
      this.recipientUserIdOrEmail &&
      this.recipientUserIdOrEmail.trim().length > 0 &&
      this.hoursToTransfer > 0 &&
      this.confirmTransfer
    );
  }

  async submit() {
    if (!this.canSubmit) {
      this.messageService.showToast('Please fill in all required fields and confirm the transfer');
      return;
    }

    this.globals.setIsLoading(true);

    try {
      const response = await this.userService.transferHoursAsync(
        this.recipientUserIdOrEmail.trim(),
        this.hoursToTransfer,
        this.comment
      );

      this.globals.setIsLoading(false);
      this.dialogRef.close(true);
      this.messageService.showToast(response.message || `Successfully transferred ${this.hoursToTransfer} hour(s)`);
    } catch (error) {
      this.globals.setIsLoading(false);
      console.error('An error occurred while transferring hours:', error);

      let errorMessage = 'Unable to transfer hours!';
      if (error.status) {
        switch (error.status) {
          case 400:
            errorMessage += ' Invalid request. Please check the entered data.';
            break;
          case 404:
            errorMessage += ' Recipient user not found.';
            break;
          case 403:
            errorMessage += ' You do not have permission to transfer hours.';
            break;
        }
      }

      this.messageService.showToast(errorMessage);
    }
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribeAll();
  }
}
